import React, { useState } from "react";
import { FaHotel } from "react-icons/fa";
import { formatDate, formatDateByLocaleShort, getCurrency } from "../../helper/Formatter";
import { FaLocationDot } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { MdEmail, MdPhone } from "react-icons/md";
import { calculatePaymentAmounts, countDaysBetweenDates, isCheckInWithinDays } from "../commonFun";

export default function RoomPriceBreakDown({branchData,appStartData,bookDetailsData, branchDataRes,walletAllData, showErr, allPayloadData, handleAddWallet, handleFinalApiCall,checkinDate ,checkOutDate}, props) {
  const tabs = ["events", "room", "service"];
  const location = useLocation();
  const [isBookingInfoExpanded, setIsBookingInfoExpanded] = useState(true);


  function calculateNights(checkinDate, checkoutDate) {
    const checkin = new Date(checkinDate);
    const checkout = new Date(checkoutDate);
    // Calculate the difference in milliseconds
    const diffTime = checkout - checkin;
    // Convert to days (nights)
    const nights = diffTime / (1000 * 60 * 60 * 24);
    return nights;
  }

  const totalNights = calculateNights(checkinDate,checkOutDate);

  const toggleBookingInfo = () => {
    setIsBookingInfoExpanded(!isBookingInfoExpanded);
  };

  // console.log('branchDataRes::: ', branchDataRes);

  const grandTotal = Number(Number(bookDetailsData?.grandtotal || 0).toFixed(2))
  const advancePercentages = Number(branchData?.appointmentsetting?.booking_advance_percentage || 0);
  const advDays =   Number(branchData?.appointmentsetting?.booking_advance_days || 0);

  const {
    total,
    advanceAmount,
    remainingAmount,
    advancePercentage: advPercent,
    remainingPercentage,
  } = calculatePaymentAmounts(grandTotal, advancePercentages , advDays);


  const numberOfDays = countDaysBetweenDates()
const insideDaysLimit = isCheckInWithinDays(advDays)

  return (
    <div>
      {/* Price Break-Up */}
      <div className="white-box background-transparent p-3 p-xl-4 mb-3">
        {/* Booking Details */}

        <>
          {tabs.includes(location.state?.bookingtype) && (
            <div className=" background-transparent  ">
              <div className="membroz-form wpcf7-form">
                <div
                  className="d-flex mb-3 justify-content-between align-items-center cursor-pointer"
                  onClick={toggleBookingInfo}
                >
                  <h5 className="">Booking Summary</h5>
                  <i
                    className={`fa icon_color ${
                      isBookingInfoExpanded
                        ? "fa-chevron-up"
                        : "fa-chevron-down"
                    }`}
                  />
                </div>

                {isBookingInfoExpanded && (
                  <>
                    <div className="resort-card mb-4  bg-white">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h5 className="resort-title mb-1">
                            <a
                              href={`https://${appStartData?.menu?.Home}`}
                              rel="noreferrer"
                              target="_blank"
                              className="text-decoration-none text-primary fw-semibold"
                            >
                              <FaHotel />
                              &nbsp;
                              {branchDataRes?.property?.emailalias}
                            </a>
                          </h5>
                        </div>
                      </div>

                      <p className="resort-address text-muted mb-2">
                        <FaLocationDot />
                        &nbsp;
                        {branchDataRes?.property?.address}&nbsp;
                        {branchDataRes?.property?.country}&nbsp;
                        {branchDataRes?.property?.pincode}
                      </p>

                      <div className="resort-contact d-flex flex-wrap align-items-center gap-3">
                        <div className="d-flex align-items-center">
                          <MdPhone />
                          &nbsp;
                          <span className="text-dark">
                            {branchDataRes?.property?.mobile1}
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <MdEmail />
                          &nbsp;
                          <span className="text-dark">
                            {branchDataRes?.property?.from}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <div className="col-6">
                        <label className="form-label">Check-in:</label>
                        <h6 className="card-title mb-1">
                          {allPayloadData?.checkin
                            ? formatDate(allPayloadData.checkin)
                            : "No Check-in Date"}
                        </h6>
                      </div>
                      <div className="col-6 border-left">
                        <label className="form-label">Check-out:</label>
                        <h6 className="card-title mb-1">
                          {allPayloadData?.checkin
                            ? formatDate(allPayloadData.checkout)
                            : "No Check-in Date"}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-4 ">
                      <h5 className="font-16">Rooms & Rates</h5>
                      {allPayloadData?.bookingdetail?.occupants?.map(
                        (item, index) => {
                          return (
                            <div className="border-bottom p-1 mb-2" key={index}>
                              <h6 className="font-16 font-weight-normal">
                                Room {index + 1} :
                              </h6>
                              <p className="m-0">
                                {item?.roomName}
                                {/* - {item?.rateTypeName} included */}
                              </p>

                              <p>
                                <strong className="font-weight-normal">
                                  Pax Details :
                                </strong>{" "}
                                {item?.adults} Adults, {item?.childrens}{" "}
                                Children
                              </p>
                              <table
                                style={{ color: "#707b8e" }}
                                className="table table-bordered"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style={{ width: "50%", color: "#707b8e" }}
                                    >
                                      <p className="m-0 font-14">
                                        Room Rates Exclusive of Tax
                                      </p>
                                    </td>
                                    <td
                                      className="text-end font-14"
                                      style={{
                                        color: "#707b8e",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {getCurrency()}&nbsp;
                                      {item?.actualcost === 0
                                        ? 0
                                        : item?.actualcost?.toFixed(2)}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 mt-3"></div>
                  </>
                )}
              </div>
            </div>
          )}
        </>

        <div className="membroz-form wpcf7-form border-top pt-3">
          <h5 className="mb-3">Price Breakdown</h5>
          <div className="pb-2 mb-2 border-bottom">
            <div className="d-flex justify-content-start">
              <div className="flex-grow-1">
                <div className="bc-right-head font_weight500">
                  {allPayloadData?.bookingdetail?.occupants?.length} Rooms x{" "}
                  {totalNights} Nights{" "}
                </div>
              </div>
              <div className="ml-3">
                <span className="bc-right-head font_weight500">
                  {getCurrency()}&nbsp;
                  {bookDetailsData?.subtotal === 0
                    ? 0
                    : bookDetailsData?.subtotal?.toFixed(2)}
                </span>{" "}
              </div>
            </div>

            <div className="d-flex justify-content-start">
              <div className="flex-grow-1 font_weight500">
                <div className="bc-right-head font_weight500">Total Taxes</div>
              </div>
              <div className="ml-3">
                <span className="bc-right-head font_weight500">
                  {getCurrency()}&nbsp;
                  {Number(
                    bookDetailsData?.taxamount ? bookDetailsData?.taxamount : 0
                  ).toFixed(2)}
                </span>{" "}
              </div>
            </div>

            <div className="d-flex justify-content-start">
              <div className="flex-grow-1 font_weight500">
                <div className="bc-right-head font_weight500">
                  Total Price (Inc. Of Taxes)
                </div>
              </div>
              <div className="ml-3">
                <span className="bc-right-head font_weight500">
                  {getCurrency()}&nbsp;
                  {total}
                </span>{" "}
              </div>
            </div>

            {(insideDaysLimit?.isWithinRange === true) ? (
             <>
             <div className="d-flex justify-content-start">
               <div className="flex-grow-1 font_weight500">
                 <div className="bc-right-head font_weight500">
                   Total Payable Now
                 </div>
               </div>
               <div className="ml-3">
                 <span className="bc-right-head font_weight500">
                   {getCurrency()}&nbsp;
                   {total}
                 </span>{" "}
               </div>
             </div>

           </>
            ) : (
              <>
                <div className="d-flex justify-content-start">
                  <div className="flex-grow-1 font_weight500">
                    <div className="bc-right-head font_weight500">
                      Total Payable Now
                    </div>
                  </div>
                  <div className="ml-3">
                    <span className="bc-right-head font_weight500">
                      {getCurrency()}&nbsp;
                      {advanceAmount}
                    </span>{" "}
                  </div>
                </div>

                <div className="d-flex justify-content-start">
                  <div className="flex-grow-1 font_weight500">
                    <div className="bc-right-head font_weight500">
                      Amount due at time of check-in
                    </div>
                  </div>
                  <div className="ml-3">
                    <span className="bc-right-head font_weight500">
                      {getCurrency()}&nbsp;
                      {remainingAmount}
                    </span>{" "}
                  </div>
                </div>
              </>
            )}

            {/* <div className="d-flex justify-content-start">
              <div className="flex-grow-1">
                <div className="bc-right-head">Wallet balance</div>
              </div>
              <div className="ml-3">
                <span className="bc-right-head">
                  {walletAllData?.walletbalance || 0}
                </span>{" "}
              </div>
            </div> */}

            {/* {showErr && (
              <div className="d-flex flex-column">
                <p className="errorMessage mt-2 mb-0">
                  Insufficient wallet balance. Please add funds to your wallet.
                </p>
                <button
                  className="add_wallet"
                  onClick={() => {
                    handleAddWallet();
                  }}
                >
                  + Add wallet
                </button>
              </div>
            )} */}
            {/* Add a button to trigger handleFinalApiCall */}
          </div>
          {/* start discount view */}
          {/* <div className="pb-2 mb-2 border-bottom">
                      <div className="d-flex justify-content-start">
                        <div className="flex-grow-1">
                          <div className="bc-right-head green-color">
                            {" "}
                            Total Discount{" "}
                          </div>
                          {finalCoupon && (
                            <div className="mt-1">
                              <span className="badge badge-success py-2 px-3 font-14">
                                <span
                                  className="mr-2 cursor-pointer"
                                  onClick={handleCancelCoupon}
                                >
                                  <i
                                    className="fa fa-close"
                                    aria-hidden="true"
                                  />
                                </span>
                                {finalCoupon?.property?.couponcode}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="ml-3">
                          <span className="bc-right-head green-color">
                            - ₹27,000
                          </span>{" "}
                        </div>
                      </div>
                    </div>
                    <div className="pb-2 mb-2 border-bottom">
                      <div className="d-flex justify-content-start">
                        <div className="flex-grow-1">
                          <div className="bc-right-head">
                            {" "}
                            Price after Discount{" "}
                          </div>
                        </div>
                        <div className="ml-3">
                          <span className="bc-right-head">₹1,68,000</span>{" "}
                        </div>
                      </div>
                    </div> */}
          {/* end discount view */}
          {/* <div className="pb-2 mb-2 border-bottom">
                      <div className="d-flex justify-content-start">
                        <div className="flex-grow-1">
                          <div className="bc-right-head"> GST 18% </div>
                        </div>
                        <div className="ml-3">
                          <span className="bc-right-head">₹27,000</span>{" "}
                        </div>
                      </div>
                    </div> */}
          <div className="">
            <div className="d-flex justify-content-start">
              <div className="flex-grow-1">
                <h6 className="mb-0"> Pay Now </h6>
              </div>

              <div className="ml-3">
                <h6 className="mb-0">
                  {getCurrency()}&nbsp;
                 {(insideDaysLimit?.isWithinRange === true)  ? total : advanceAmount}
                  {/* {Number(Number(bookDetailsData?.grandtotal || 0).toFixed(2))} */}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Apply Coupon */}
      {/* <div className="white-box background-transparent p-3 p-xl-4"> */}
      {/* <form className="membroz-form wpcf7-form">
                    <h5 className="mb-3">Apply Coupon</h5>
                    <div className="form-group input-group">
                      <input
                        type="text"
                        className="form-control font-14"
                        placeholder="Enter Coupon Code"
                        aria-label="Enter Coupon Code"
                        aria-describedby="button-addon2"
                        value={couponCode?.property?.couponcode}
                        onChange={(e) => handleOnchangeCouponCode(e)}
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-primary"
                          type="button"
                          disabled={!couponCode}
                          id="button-addon2"
                          onClick={handleApplyCouponCode}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    <div className="mt-4 d-block">
                      {couponData
                        ?.filter((item) => item?.status === "active")
                        .map((item, index) => {
                          let couponName = item?.property?.couponcode;
                          let couponDiscount = item?.property?.discount;
                          let couponDesc = item?.property?.description;
                          return (
                            <div className="border-top p-2" key={index}>
                              <div className="d-flex justify-content-start mb-1">
                                <div className="flex-grow-1">
                                  <h6 className="mb-0">{couponName} </h6>
                                </div>

                              </div>
                              <div className="font-14">{couponDesc}</div>
                              <div className="d-flex justify-content-end">
                                <button
                                  href="#"
                                  className="btn btn-outline-info font-14"
                                  onClick={(e) => handleCouponVal(e, item)}
                                >
                                  Apply
                                </button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </form> */}

      {/* {couponData && (
        <div className="mt-3 alert alert-success">
          <strong>Applied Coupon:</strong> {couponData.property.couponcode} -{" "}

        </div>
      )} */}
      {/* </div> */}
    </div>
  );
}
